<script setup lang="ts">
/**
 * Registro del service worker (registerType "prompt"): cuando hay una version nueva desplegada se
 * ofrece actualizar en vez de recargar sola (la clienta puede estar a mitad de una revision).
 */
import { PhArrowClockwise } from "@phosphor-icons/vue";
import { useRegisterSW } from "virtual:pwa-register/vue";
import { watch } from "vue";

import { useUiStore } from "@/stores/ui";

const HOURLY = 60 * 60 * 1000;
const ui = useUiStore();

const { needRefresh, offlineReady, updateServiceWorker } = useRegisterSW({
  immediate: true,
  onRegisteredSW(_url, registration) {
    // Las PWA instaladas pueden quedar abiertas dias: se busca una version nueva cada hora.
    if (registration) setInterval(() => void registration.update(), HOURLY);
  },
});

watch(offlineReady, (ready) => {
  if (ready) ui.showToast("Lista para abrirse sin conexión.");
});
</script>

<template>
  <div v-if="needRefresh" class="update" role="alert">
    <span>Hay una versión nueva de la app.</span>
    <div class="update-actions">
      <button type="button" class="btn btn-ghost" @click="needRefresh = false">Luego</button>
      <button type="button" class="btn btn-primary" @click="updateServiceWorker(true)">
        <PhArrowClockwise :size="18" aria-hidden="true" />Actualizar
      </button>
    </div>
  </div>
</template>

<style scoped>
.update {
  position: fixed;
  z-index: 40;
  right: calc(16px + var(--safe-right));
  bottom: calc(16px + var(--safe-bottom));
  left: auto;
  width: min(380px, calc(100% - 32px));
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px 12px;
  padding: 12px 12px 12px 16px;
  border-radius: var(--radius-lg);
  background: var(--color-surface);
  box-shadow: var(--shadow-lg);
  font-size: 14px;
}
.update-actions {
  display: flex;
  gap: 6px;
  margin-left: auto;
}
</style>
